module.exports = __webpack_public_path__ + "media/img/circle-arrow-right-solid-15b19ed0c70cecd7be36cd698504a550.svg";